const loadPreloadedLinks = () => {
    document.querySelectorAll('link[rel="preload"][as="style"]').forEach((linkElement) => {
        linkElement.rel = 'stylesheet';
    });
};
export const initPreload = () => {
    document.addEventListener('DOMContentLoaded', function () {
        loadPreloadedLinks();
    });
};
